import { cloneElement, forwardRef, isValidElement, useState } from 'react';
import { Dropdown as AntdDropdown } from 'antd';
import './Dropdown.module.css';

/**
 * @param {Object} props - Same shape as antd's own `Dropdown`, forwarded as-is. antd never sets
 *   `aria-haspopup` / `aria-expanded` on the trigger, so this wrapper tracks the open state and
 *   adds them to the (single element) child.
 */
const Dropdown = forwardRef(({ children, open, defaultOpen, onOpenChange, ...rest }, ref) => {
    const [innerOpen, setInnerOpen] = useState(defaultOpen ?? false);
    const mergedOpen = open ?? innerOpen;

    const handleOpenChange = (nextOpen, info) => {
        setInnerOpen(nextOpen);
        onOpenChange?.(nextOpen, info);
    };

    const trigger = isValidElement(children)
        ? cloneElement(children, {
              'aria-haspopup': rest.menu ? 'menu' : 'true',
              'aria-expanded': mergedOpen,
              ...children.props,
          })
        : children;

    return (
        <AntdDropdown
            ref={ref}
            open={open}
            defaultOpen={defaultOpen}
            onOpenChange={handleOpenChange}
            {...rest}
        >
            {trigger}
        </AntdDropdown>
    );
});
Dropdown.displayName = 'Dropdown';

export default Dropdown;
